import type { EntryCheckResponse } from '@shared/entry';
import { create } from 'zustand';

import { entryApi } from '../api/entryApi';

export type EntryStatus = 'idle' | 'loading' | 'ready' | 'blocked' | 'error';

interface EntryStore {
  status: EntryStatus;
  data: EntryCheckResponse | null;
  error: string | null;
  refetch: () => Promise<void>;
  reset: () => void;
}

export const useEntryStore = create<EntryStore>((set) => ({
  status: 'idle',
  data: null,
  error: null,

  refetch: async () => {
    set({ status: 'loading' });
    try {
      const data = await entryApi.check();
      const isBlocked = data.blacklist.status === 'BLOCKED';
      set({ status: isBlocked ? 'blocked' : 'ready', data, error: null });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Entry check failed';
      set({ status: 'error', error: message });
    }
  },

  reset: () => set({ status: 'idle', data: null, error: null }),
}));
